import { CustomValidator } from "@rjsf/utils";
import { useMemo } from "react";

import { EditGMNMeasuringPointTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GmnMeasuringPointFormProps } from "@/types/form-types";

import { useGmnUiSchema } from "../../schema/gmn-ui-schema";

import { getEditGmnMeasuringPointSchema } from "./schema/edit-gmn-measuring-point-schema";

export function EditGmnMeasuringPointForm(props: GmnMeasuringPointFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { formData, handleChange } = useBrostarFormDataStorage<EditGMNMeasuringPointTask>({
    key: "editGmnMeasuringPoint",
    task: task,
  });

  const uiSchema = useGmnUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(() => getEditGmnMeasuringPointSchema(type), [type]);

  const customValidate: CustomValidator<EditGMNMeasuringPointTask> = (formData, errors) => {
    const date = formData?.sourcedocumentData?.eventDate;
    if (date && new Date(date) > new Date()) {
      errors["sourcedocumentData"]?.["eventDate"]?.addError("Datum mag niet in de toekomst zijn");
    }
    return errors;
  };

  const onSubmit = async () => {
    if (!formData) return;
    await api.editGmnMeasuringPoint(formData);
    // FUTURE: Implement upload task editing
    // if (oldUploadTask?.uuid) await api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      customValidate={customValidate}
      uploadTask={oldUploadTask}
    />
  );
}
